import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

import { userId, type UserId } from './User.js'

/** Identifier type for public.user_remember_token_ */
export type UserRememberTokenId = string & { __brand: 'UserRememberTokenId' }

/** Represents the table public.user_remember_token_ */
export default interface UserRememberTokenTable {
  /** Database type: pg_catalog.uuid */
  id: ColumnType<
    UserRememberTokenId,
    UserRememberTokenId | undefined,
    UserRememberTokenId
  >

  /** Database type: pg_catalog.uuid */
  userId: ColumnType<UserId, UserId, UserId>

  /** Database type: pg_catalog.text */
  tokenHash: ColumnType<string, string, string>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>

  /** Database type: pg_catalog.timestamptz */
  expiresAt: ColumnType<Date, Date | string, Date | string>

  /** Database type: pg_catalog.text */
  userAgent: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.text */
  ip: ColumnType<string | null, string | null, string | null>
}

export type UserRememberToken = Selectable<UserRememberTokenTable>

export type UserRememberTokenInitializer = Insertable<UserRememberTokenTable>

export type UserRememberTokenMutator = Updateable<UserRememberTokenTable>

export const userRememberTokenId =
  z.string() as unknown as z.Schema<UserRememberTokenId>

export const userRememberToken = z.object({
  id: userRememberTokenId,
  userId: userId,
  tokenHash: z.string(),
  createdAt: z.coerce.date(),
  expiresAt: z.coerce.date(),
  userAgent: z.string().nullable().optional(),
  ip: z.string().nullable().optional(),
}) as unknown as z.Schema<UserRememberToken>

export const userRememberTokenInitializer = z.object({
  id: userRememberTokenId.optional(),
  userId: userId,
  tokenHash: z.string(),
  createdAt: z.coerce.date().optional(),
  expiresAt: z.coerce.date(),
  userAgent: z.string().optional().nullable(),
  ip: z.string().optional().nullable(),
}) as unknown as z.Schema<UserRememberTokenInitializer>

export const userRememberTokenMutator = z.object({
  id: userRememberTokenId.optional(),
  userId: userId.optional(),
  tokenHash: z.string().optional(),
  createdAt: z.coerce.date().optional(),
  expiresAt: z.coerce.date().optional(),
  userAgent: z.string().optional().nullable(),
  ip: z.string().optional().nullable(),
}) as unknown as z.Schema<UserRememberTokenMutator>
